import React from "react";
import Sort from "./Sort";

function Categories({ sortValue, clickPopUp, value, onClickCategory }){

    const categories = [ 'All', 'TeamKit', 'Jersey', 'Glasses', 'T-shirts', 'Hats' ];

    // const onClickCategory = (index) => {
    //   setActiveIndex(index)
    // }

    return(
        <div className="content">
            <div className="container">
                <div className="content__top">
                    <div className="categories">
                        <ul>

                            {
                                categories.map((category, i) =>
                                    <li key={i} onClick={() => onClickCategory(i)} className={value === i ? "active" : ''}>{category}</li>
                                )
                            }

                        </ul>
                    </div>
                    <Sort sortValue={sortValue} clickPopUp={clickPopUp} />
                </div>
            </div>
        </div>
    );
}
export default Categories;